(
    function (skyward, $, undefined)
    {
        var factory = new skyward.menusecurity.MenuSecurityViewFactory();

        // TODO make all of this stuff unique to the control instead of assuming there's only one on the screen.
        skyward.menusecuritylayout = skyward.menusecuritylayout || {};
        skyward.menusecuritylayout.loadPortal = function (portalCode) { };

        var deserializeJsonValues = function (jsonObject, target, ignoredProperties)
        {
            for (var key in jsonObject)
            {
                if (!ignoredProperties.includes(key))
                {
                    if (typeof target[key] === "function")
                    {
                        target[key](jsonObject[key], null, false);
                    }
                    else
                    {
                        target[key] = jsonObject[key];
                    }
                }
            }
        }

        var getMenuSecurityItems = function (itemsListJson)
        {
            var result = [];
            for (var item in itemsListJson)
            {
                if (itemsListJson[item].Name.toUpperCase() === "FEATURES" || itemsListJson[item].Name.toUpperCase() === "REPORTS")
                {
                    itemsListJson[item]["Column"] = 0;
                }
                else
                {
                    itemsListJson[item]["Column"] = 1;
                }

                if (itemsListJson[item].Type == "Group")
                {
                    var msig = new skyward.menusecurity.MenuSecurityItemGroup();
                    var ignoredProperties = ["Type", "Items"];
                    deserializeJsonValues(itemsListJson[item], msig, ignoredProperties);

                    var itemsJson = itemsListJson[item].Items;
                    var items = getMenuSecurityItems(itemsJson);
                    for (var j in items)
                    {
                        msig.AddMember(items[j]);
                    }
                    result.push(msig);
                }
                else if (itemsListJson[item].Type == "SecurityItem")
                {
                    var msi = new skyward.menusecurity.MenuSecurityItem();
                    var ignoredProperties = ["Type"];

                    deserializeJsonValues(itemsListJson[item], msi, ignoredProperties);
                    result.push(msi);
                }
            }
            return result;
        }

        var getMenuSecurityItemTree = function (jsonData)
        {
            var results = [];
            for (var module in jsonData.Modules)
            {
                var item = new skyward.menusecurity.MenuSecurityItemGroup();
                var ignoredProperties = ["Type", "Categories"];
                deserializeJsonValues(jsonData.Modules[module], item, ignoredProperties);

                var items = getMenuSecurityItems(jsonData.Modules[module].Categories);
                for (var j in items)
                {
                    item.AddMember(items[j]);
                }
                results.push(item);
            }
            return results;
        }

        var toggleSecurityGrantedIcon = function (portalCode, markLoaded)
        {
            if (markLoaded)
            {
                $(".menuSecurityPortalButton[data-portal='" + portalCode + "']").addClass("loaded");
            }

            var accessIcon = $("a[data-portal='" + portalCode + "'] svg.menuSecurityPortalButtonSecurityAccess");
            if ($(".menuSecurityGrid[data-portal='" + portalCode + "'] .menuSecurityModuleSecurityAccess.granted").length > 0)
            {
                accessIcon.addClass("granted");
            }
            else
            {
                accessIcon.removeClass("granted");
            }
        }

        // Creates the views for the modules on the left side.
        var populateModuleList = function (moduleContainerSelector, moduleTableContainerSelector, menuSecurityItemTree, portalCode)
        {
            var generateModuleClickEvent = function (portalCode, moduleName)
            {
                return function ()
                {
                    skyward.menusecuritylayout.displayItemsForModule(portalCode, moduleName);
                }
            }

            var table = $(moduleTableContainerSelector)[0];


            for (var i in menuSecurityItemTree)
            {
                var row = factory.CreateView(menuSecurityItemTree[i], function (view, model)
                {
                    view.addClass("moduleRow");
                    var label = view.find("label")[0];
                    $(label).text(model.Name());
                    $(label).addClass("menuSecurityModuleText");
                    var svg = view.find("svg.menuModuleSvg.menuSecurityTemplate ");
                    svg.removeClass("menuSecurityTemplate");
                    svg.find("use").attr("xlink:href", skyward.global.virtualDir + "SkySys/Svg/spritesheet?v=3#svg-" + model.ImageCode);

                    var securityIndicator = view.find("svg.menuSecurityModuleSecurityAccess.menuSecurityTemplate");
                    securityIndicator.removeClass("menuSecurityTemplate");

                    var newAnchor = "<a class='menuSecurityModuleLabel' href='javascript:void(0)'></a>";
                    securityIndicator.before(newAnchor);
                    view.find("td.menuSecurityGridLabel a").append(svg, label);

                    // If the module panel is collapsed, make sure these load up as collapsed as well.
                    if ($(moduleContainerSelector).hasClass("moduleCollapsed"))
                    {
                        view.find("td.menuSecurityGridPermission").addClass("menuSecurityModuleItemCellCollapsed");
                    }

                }, function ()
                {
                    toggleSecurityGrantedIcon(portalCode);
                });
                row.click(generateModuleClickEvent(portalCode, menuSecurityItemTree[i].Name()));
                $(table).append(row);
                getAlternatingRows($(table));
            }
        }

        var markUnloadedPortalsAsHavingSecurity = function (items)
        {
            for (var i in items)
            {
                $(".menuSecurityPortalButton[data-portal='" + items[i] + "']:not(.loaded) .menuSecurityPortalButtonSecurityAccess").addClass("granted");
            }
        }

        var deserializePortal = function (jsonData)
        {
            var generateModuleGrid = function (portalCode)
            {
                var result = $(".menuSecurityGridTemplate").first().clone(); // Could be more specific.
                result.removeClass("menuSecurityGridTemplate");
                result.addClass("menuSecurityLayoutInactive");
                result.attr("data-portal", portalCode);
                return result;
            }

            var portalCode = jsonData.Portal;
            var loadedPortals = $(".menuSecurityPortalButton.loaded").map(function () { return $(this).attr("data-portal"); }).get();

            if (!loadedPortals.includes(portalCode))
            {
                loadedPortals.push(portalCode);
                var allGrantedPortals = jsonData.AllPortalsForRole;
                var containerTable = generateModuleGrid(jsonData.Portal);
                $("div.menuContainer div.moduleContainer div.menuSecurityItemGridContainer").append(containerTable);

                var modelTree = getMenuSecurityItemTree(jsonData);
                populateModuleList("div.moduleContainer div.menuSecurityItemBody", "div.moduleContainer table.menuSecurityGrid[data-portal='" + portalCode + "']", modelTree, portalCode);

                // Generate all of the views for the categories and their items.
                for (var i in modelTree)
                {
                    createItemLayoutForModule(portalCode, modelTree[i]);
                }

                skyward.menusecuritylayout.displayModulesForPortal(portalCode);

                toggleSecurityGrantedIcon(portalCode, true);
                markUnloadedPortalsAsHavingSecurity(allGrantedPortals);
            }
        }

        var hideAllMenuSecurityLocationContainers = function ()
        {
            var allMenuSecurityLocationContainers = $("div.menuContainer div.menuSecurityCategoryContainer table.menuSecurityGrid");
            allMenuSecurityLocationContainers.each(function () { $(this).addClass("menuSecurityLayoutInactive") });
            return allMenuSecurityLocationContainers;
        }

        skyward.menusecuritylayout.displayModulesForPortal = function (portalCode, roleID)
        {
            $(".menuSecurityPortalButton").removeClass("menuSecurityPortalButtonSelected");
            $(".menuSecurityPortalButton[data-portal='" + portalCode + "']").addClass("menuSecurityPortalButtonSelected");

            // TODO add selector for the layout control's ID.
            // Locate and hide all existing module divs.
            var allModuleGrids = $("div.moduleContainer table.menuSecurityGrid"); // TODO this is a weird selector.
            allModuleGrids.each(function () { $(this).addClass("menuSecurityLayoutInactive") });

            hideAllMenuSecurityLocationContainers();

            // if the one for the portal we want doesn't exist yet, load it.
            var existingModuleContainer = allModuleGrids.filter(function () { return $(this).data("portal") == portalCode; });
            if (existingModuleContainer.length > 0)
            {
                $(existingModuleContainer[0]).removeClass("menuSecurityLayoutInactive");

                var moduleViews = $(existingModuleContainer[0]).find("tr[data-name]");

                // Auto-select the top module.
                if (moduleViews.length > 0)
                {
                    skyward.menusecuritylayout.displayItemsForModule(portalCode, $(moduleViews[0]).attr("data-name"));
                }
            }
            else if (roleID != undefined)
            {
                // Load the portal.
                retrieveMenuSecurityItemsForPortal(portalCode, roleID); // TODO hardcoded roleid.
            }

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/Role/UpdateMenuSecurityPagestate",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        PortalCode: portalCode
                    }
                });
        }

        var collapseItem = function (tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, expandButton, collapseButton, itemtype)
        {
            var expandedChildren = $(tableElement).find("tr[data-toplevelparentview='" + topLevelParentViewName + "'][data-parentview='" + parentViewName + "'][data-parentviewmenuscreenid='" + parentViewMenuScreenID + "'][data-parenttype='" + itemtype + "']");
            expandedChildren.addClass("menuSecurityItemCollapsed");
            expandButton.addClass("buttonSvg");
            expandButton.removeClass("svgHidden");
            collapseButton.removeClass("buttonSvg");
            collapseButton.addClass("svgHidden");

            expandedChildren.each(function () 
            {
                var expandedChild = $(this);
                collapseItem(tableElement, expandedChild.attr("data-name"), expandedChild.attr("data-menuscreenid"), parentViewName, expandedChild.find("svg.menuSecurityItemExpand"), expandedChild.find("svg.menuSecurityItemCollapse"), expandedChild.attr("itemType")); 
            });
        }

        var getChildToggleFunction = function (collapsed, tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, layer)
        {
            return function (view, model)
            {
                view.find("td").addClass("menuSecurityCategoryGridCell");

                var label = view.find("label")[0];  
                $(label).text(model.Name());
                $(label).addClass("menuSecurityLayer" + layer + "Label");
                var itemtype = "layer" + layer;
                view.attr("itemType", itemtype);
                if (collapsed)
                {
                    view.addClass("menuSecurityItemCollapsed");
                }

                if (model instanceof skyward.menusecurity.MenuSecurityItemGroup)
                {
                    var toggleButton = $(view).find("a.menuSecurityItemToggleChildren");
                    toggleButton.removeClass("menuSecurityTemplate");
                    toggleButton.click(function ()
                    {
                        var children = $(tableElement).find("tr.menuSecurityItemCollapsed[data-toplevelparentview='" + topLevelParentViewName + "'][data-parentview='" + parentViewName + "'][data-parentviewmenuscreenid='" + parentViewMenuScreenID + "'][data-parenttype='" + itemtype + "']");
                        var collapsed = children.length > 0;
                        var expandButton = $(view).find("svg.menuSecurityItemExpand");
                        var collapseButton = $(view).find("svg.menuSecurityItemCollapse");

                        // Toggle children.
                        if (collapsed)
                        {
                            children.removeClass("menuSecurityItemCollapsed");
                            expandButton.removeClass("buttonSvg");
                            expandButton.addClass("svgHidden");
                            collapseButton.addClass("buttonSvg");
                            collapseButton.removeClass("svgHidden");
                            if (layer == 1)
                            {
                                $(view).find("td.menuSecurityGridLabel").removeClass("childrenNotExpanded");
                                $(view).find("td.menuSecurityGridLabel").addClass("childrenExpanded");
                            }
                        }
                        else
                        {
                            collapseItem(tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, expandButton, collapseButton, itemtype);
                            $(view).find("td.menuSecurityGridLabel").addClass("childrenNotExpanded");
                            $(view).find("td.menuSecurityGridLabel").removeClass("childrenExpanded");
                        }

                        getAlternatingRows(tableElement);
                    });
                }
            }
        }

        // Profile sub-tabs.
        var populateThirdLayerItems = function (tableElement, profileTabRoot)
        {
            var results = [];
            for (var i in profileTabRoot.members)
            {
                var row = factory.CreateView(profileTabRoot.members[i], function (view, model)
                {
                    view.attr("itemType", "layer3");
                    var label = view.find("label")[0];
                    $(label).text(model.Name());
                    $(label).addClass("menuSecurityLayer3Label");
                    view.addClass("menuSecurityItemCollapsed");
                    view.find("td").addClass("menuSecurityCategoryGridCell");
                    $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabItem");

                    if (i == profileTabRoot.members.length - 1)
                    {
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabItemLast");
                    }

                });
                results.push(row);
            }
            return results;
        }

        // Profile categories
        var populateSecondLayerItems = function (tableElement, profileRoot)
        {
            var results = [];
            for (var i in profileRoot.members)
            {
                var currentMember = profileRoot.members[i];

                var childRows = populateThirdLayerItems(tableElement, currentMember);
                for (var j in childRows)
                {
                    childRows[j].attr("data-toplevelparentview", profileRoot.Name());
                    childRows[j].attr("data-parentview", currentMember.Name());
                    childRows[j].attr("data-parentviewmenuscreenid", currentMember.MenuScreenID);
                    childRows[j].attr("data-parenttype", "layer2");
                }
                var childToggleFunction = getChildToggleFunction(true, tableElement, currentMember.Name(), currentMember.MenuScreenID, profileRoot.Name(), 2);
                var row = factory.CreateView(currentMember,
                    function (view, model)
                    {
                        childToggleFunction(view, model);
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabGroup");
                    });

                results.push(row);
                for (var j in childRows)
                {
                    results.push(childRows[j]);
                }
            }
            return results;
        }

        // Profile or items
        var populateFirstLayerItems = function (tableElement, categoryRoot, column)
        {
            for (var i in categoryRoot.members)
            {
                var currentMember = categoryRoot.members[i];

                var childRows = populateSecondLayerItems(tableElement, currentMember);
                for (var j in childRows)
                {
                    if (!childRows[j].attr("data-parentview"))
                    {
                        childRows[j].attr("data-toplevelparentview", categoryRoot.Name());
                        childRows[j].attr("data-parentview", currentMember.Name());
                        childRows[j].attr("data-parentviewmenuscreenid", currentMember.MenuScreenID);
                        childRows[j].attr("data-parenttype", "layer1");
                    }
                }

                var childToggleFunction = getChildToggleFunction(false, tableElement, currentMember.Name(), currentMember.MenuScreenID, categoryRoot.Name(), 1);

                var row = factory.CreateView(currentMember,
                    function (view, model)
                    {
                        childToggleFunction(view, model);
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfile");
                        $(view).find("td.menuSecurityGridLabel").addClass("childrenNotExpanded");
                        $(view).find("td.menuSecurityGridLabel").addClass("column" + column);
                    });

                $(tableElement).append(row);
                for (var j in childRows)
                {
                    $(tableElement).append(childRows[j]);
                }
            }
        }

        var getAlternatingRows = function (table)
        {
            var rows = table.find("tr");
            var alternator = false;

            rows.each(function ()
            {
                $(this).removeClass("permissionRow0");
                $(this).find("td.menuSecurityGridPermission").each(function () { $(this).removeClass("permissionCell0") });
                $(this).removeClass("permissionRow1");
                $(this).find("td.menuSecurityGridPermission").each(function () { $(this).removeClass("permissionCell1") });

            });

            rows.each(function ()
            {
                if (!$(this).hasClass("menuSecurityItemCollapsed"))
                {
                    if ($(this).attr("itemType") == "category")
                    {
                        alternator = false;
                    }
                    else
                    {
                        alternator = !alternator;
                        $(this).addClass(alternator ? "permissionRow0" : "permissionRow1");
                        $(this).find("td.menuSecurityGridPermission").each(function () { $(this).addClass(alternator ? "permissionCell0" : "permissionCell1") });
                    }
                }
            });
        }

        var populateItemLayoutForModule = function (table0, table1, moduleRoot)
        {
            var tables = [table0, table1];
            for (var i in moduleRoot.members)
            {
                var row = factory.CreateView(moduleRoot.members[i], function (view, model)
                {
                    view.find("td").addClass("menuSecurityCategoryCell");
                    var label = view.find("label")[0];
                    $(label).text(model.Name());
                    view.attr("itemType", "category");
                    $(label).addClass("menuSecurityCategoryLabel");

                });
                var table = tables[moduleRoot.members[i].Column];
                $(table).append(row);
                if (moduleRoot.members[i].members.length > 0)
                {
                    populateFirstLayerItems(table, moduleRoot.members[i], moduleRoot.members[i].Column);
                    getAlternatingRows(table);
                }
            }
        }

        var createItemLayoutForModule = function (portalCode, moduleRoot)
        {
            var table0 = $("table.menuSecurityGridTemplate").first().clone();
            table0.removeClass("menuSecurityGridTemplate");
            table0.attr("data-module", moduleRoot.Name());
            table0.attr("data-portal", portalCode);
            table0.insertBefore($("div.menuSecurityCategoryContainer0 .menuSecurityFillerContainer "));

            var table1 = $("table.menuSecurityGridTemplate").first().clone();
            table1.removeClass("menuSecurityGridTemplate");
            table1.attr("data-module", moduleRoot.Name());
            table1.attr("data-portal", portalCode);
            table1.insertBefore($("div.menuSecurityCategoryContainer1 .menuSecurityFillerContainer"));

            populateItemLayoutForModule(table0, table1, moduleRoot);
        }

        skyward.menusecuritylayout.displayItemsForModule = function (portalCode, moduleName)
        {
            var allMenuSecurityLocationContainers = hideAllMenuSecurityLocationContainers();

            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow td.menuSecurityGridLabel").removeClass("moduleLabelSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow td.menuSecurityGridLabel div.MenuSecurityItemNameContainer").removeClass("menuSecurityItemModuleSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow[data-name='" + moduleName + "'] td.menuSecurityGridLabel").addClass("moduleLabelSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow[data-name='" + moduleName + "'] td.menuSecurityGridLabel div.MenuSecurityItemNameContainer").addClass("menuSecurityItemModuleSelected");

            var existingLocationContainer = allMenuSecurityLocationContainers.filter(function () { return $(this).attr("data-module") == moduleName && $(this).attr("data-portal") == portalCode; });
            existingLocationContainer.removeClass("menuSecurityLayoutInactive");
        }

        var retrieveMenuSecurityItemsForPortal = function (portalCode, roleID)
        {
            $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/RoleMenuSecurityItem/GetMenuSecurityItems",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        PortalCode: portalCode,
                        RoleID: roleID
                    },
                    success: function (data) 
                    {
                        deserializePortal(data);
                    }
                    // TODO error:
                });
        }

        var toggleCollapsedFeaturesContainer = function (tableContainer, clss, targetClass)
        {
            return tableContainer.addClass(targetClass).removeClass(clss);
        }

        // Collapse/Expand the module container, but leave the labels for the module so you can see what's selected.
        var toggleCollapsedModuleContainer = function (container, tableContainer, collapse)
        {
            var tds = container.find("td.menuSecurityGridPermission");
            if (collapse)
            {
                container.find("td.menuSecurityGridPermission").addClass("menuSecurityModuleItemCellCollapsed");
                $(tableContainer).addClass("moduleCollapsed");
            }
            else
            {
                container.find("td.menuSecurityGridPermission.menuSecurityModuleItemCellCollapsed").removeClass("menuSecurityModuleItemCellCollapsed");
                $(tableContainer).removeClass("moduleCollapsed");
            }
            return container;
        }

        var initializeCollapsePanel = function (selector)
        {
            $(selector + " .menuSecurityItemContainer").each(function ()
            {
                var button = $(this).find(".toggleMenuSecurityGrid");
                var tableContainer = $(this).find(".menuSecurityItemBody");

                var expandMethod;
                var collapseMethod;

                var collapsingModuleContainer = $(this).hasClass("moduleContainer")
                if (collapsingModuleContainer)
                {
                    var container = $(this);
                    expandMethod = function () { return toggleCollapsedModuleContainer(container, tableContainer).promise(); };
                    collapseMethod = function () { return toggleCollapsedModuleContainer(container, tableContainer, true).promise(); };
                }
                else
                {
                    expandMethod = function () { return toggleCollapsedFeaturesContainer(tableContainer, "collapsed", "expanded").promise(); };
                    collapseMethod = function () { return toggleCollapsedFeaturesContainer(tableContainer, "expanded", "collapsed").promise(); };
                }

                $(button).click(function ()
                {
                    var expanded = !collapsingModuleContainer ? tableContainer.hasClass("expanded") : tableContainer.find("td.menuSecurityGridPermission.menuSecurityModuleItemCellCollapsed").length == 0;
                    if (expanded)
                    {
                        collapseMethod().done(
                            function () 
                            {
                                button.find("use").attr("xlink:href", skyward.global.virtualDir + "SkySys/Svg/spritesheet?v=3#svg-ChevronRight");
                            });
                    }
                    else 
                    {
                        expandMethod().done(
                            function () 
                            {
                                button.find("use").attr("xlink:href", skyward.global.virtualDir + "SkySys/Svg/spritesheet?v=3#svg-ChevronLeft");
                            });
                    }

                });
            });
        }

        var init = function (selector)
        {
            // TODO make this work if it's run multiple times.
            var initializeLayout = function (id)
            {
                var roleID = $(selector + " #" + id).attr("data-roleid");
                var initialPortalCode = $(selector + " .initialPortalCode").val();

                skyward.menusecuritylayout.displayModulesForPortal(initialPortalCode, roleID);
            }

            $(selector + " div.menuSecurityLayout").each(function ()
            {
                var roleID = $(this).attr("data-roleid");
                var portalButtons = $(this).find("a.menuSecurityPortalButton");

                portalButtons.each(function ()
                {
                    $(this).click(function ()
                    {
                        skyward.menusecuritylayout.displayModulesForPortal($(this).attr("data-portal"), roleID);
                    });
                });

                initializeLayout(this.id);
            });

            initializeCollapsePanel(selector);
        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);